import React, { useEffect, useRef, useState } from "react"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"
import Image from "./image"

export default function MobileSubNavigation({ current, id }) {
  const activeItem = useRef()
  const [expanded, setExpanded] = useState(false)

  const handleScroll = () => {
    var height = document.documentElement.scrollHeight - window.innerHeight
    var scrollY = window.pageYOffset
    var progress = Math.round((scrollY / height) * 100)
    if (activeItem.current) {
      activeItem.current.style.width = progress + "%"
    }
  }

  const setActive = name => {
    if (current === name) {
      return "sub-navigation--active"
    } else if (!current) {
      return "sub-navigation--active"
    } else {
      return null
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  })

  const renderChildren = () => {
    const parentMenu = findObject(menuData, "id", id)
    if (parentMenu === undefined) {
      return null
    }
    const menu = parentMenu.children
    const location = menu.findIndex(item => item.id.includes(current))
    const currentItem = location !== -1 ? menu[location] : parentMenu

    const items = menu.map((item, index) => {
      return item.id !== current ? (
        <li
          key={index}
          className={setActive(item.id, index)}
          aria-hidden={expanded ? "false" : "true"}
        >
          <Link className="sub-navigation__item" to={item.href}>
            {item.thumbnail && (
              <div className="sub-navigation__item__image">
                <Image path={item.thumbnail} />
              </div>
            )}
            <div className="sub-navigation__item__text">
              <div className="sub-navigation__item__text__title">
                {item.name}
              </div>
            </div>
          </Link>
        </li>
      ) : null
    })

    return (
      <>
        <li className="sub-navigation--active">
          <button
            onClick={() => setExpanded(!expanded)}
            className="icon--chevron"
            aria-controls="sub-navigation__menu"
          >
            <div className="sub-navigation__progress">
              <div className="sub-navigation__progress__bar" ref={activeItem} />
            </div>

            <div className="sub-navigation__item">
              {currentItem.thumbnail && (
                <div className="sub-navigation__item__image">
                  <Image path={currentItem.thumbnail} />
                </div>
              )}
              <div className="sub-navigation__item__text">
                <div className="sub-navigation__item__text__title">
                  {currentItem.name}
                </div>
              </div>
            </div>
          </button>
        </li>
        {items}
      </>
    )
  }

  return (
    <nav className="sub-navigation util__mobile-only">
      <ul
        id="sub-navigation__menu"
        className={
          expanded
            ? `container sub-navigation__menu sub-navigation__menu--expanded`
            : `container sub-navigation__menu`
        }
      >
        {renderChildren()}
      </ul>
    </nav>
  )
}
